import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'

import { Row, Col } from 'react-flexbox-grid'
import { Checkbox } from 'components/forms'

export const StyledColItem = styled(Col)`
	position: relative;
`

export const StyledRow = styled(Row).withConfig({
	shouldForwardProp: prop => !['isWideSide'].includes(prop)
})`
	flex-wrap: nowrap;
	${StyledColItem} {
		max-width: ${({ theme, isWideSide }) => `calc(100% - ${isWideSide ? theme?.sectionColWidth?.wide : theme?.sectionColWidth?.normal})`};
	}
`

/*
	To handle Col width can be used (in order of priority):
	- standard Col 'xs'(Number) prop;
	- 'width'(String) prop in valid CSS width property;
	- 'wide'(Boolean) to use predefined width;
*/
export const StyledColList = styled(Col).withConfig({
	shouldForwardProp: prop => !['wide'].includes(prop)
})`
${({ wide, width, xs, theme }) => {
	const { wide: themeWide, normal } = get(theme, 'sectionColWidth', {})
	const colWidth = width || (wide ? themeWide : normal)
	return !(typeof xs === 'number') && `
			width: ${colWidth};
			max-width: ${colWidth};
			min-width: ${colWidth};
			flex-basis: ${colWidth};
			transition: 0.3s;
		`
}}
.ReactTable {
	height: ${({ theme = {} }) => {
	const { mainSections = 0, bottomNav = 0 } = get(theme, 'navBarHeight', {})
	const { contentHeaderHeight = 0 } = theme
	// 7px is content top padding, 20px is content bottom padding, 5px is contentHeader bottom margin
	const paddings = 7 + 20 + 5 + 'px'
	return `calc(100vh - ${mainSections} - ${bottomNav} - ${contentHeaderHeight} - ${paddings})`
}};
		min-height: 630px;
	}
`

export const StyledCheckbox = styled((pr) => <Checkbox {...pr} />)`
	.box {
		background-color: white;
	}
`
